export const APPLICATIONS_FAQ_URL = 'https://zillow.zendesk.com/hc/en-us/sections/360000067967-Rental-Applications';
export const LANDLORD_SCREENING_FAQ_URL = 'https://www.zillow.help/article/screening-reports-zd32873619235091';
export const ASSISTANCE_ANIMALS_URL = 'https://www.hud.gov/program_offices/fair_housing_equal_opp/assistance_animals';
export const CIC_SUPPORT_URL = 'https://www.cicreports.com/consumer-assistance/';
export const CO_APPLICANT_FAQ_URL = 'https://www.zillow.help/article/how-do-i-add-a-co-applicant-zd360000620888/';
export const CONDITIONAL_APPROVAL_URL =
  'https://zillow.zendesk.com/hc/en-us/articles/34495429077395-Conditional-Approval-FAQs';
export const EXPERIAN_DISPUTE_URL = 'https://www.experian.com/disputes/main.html';
export const EXPERIAN_NOTICE_TO_USERS_URL = 'https://www.experian.com/connect/legal/fcra-obligations';
export const FAIR_HOUSING_URL = 'https://www.zillow.com/learn/fair-housing-act/';
export const FTC_CONSUMER_REPORTS_URL =
  'https://www.ftc.gov/business-guidance/blog/2016/11/screening-tenants-check-out-ftcs-new-guidance';
export const GOOD_NEIGHBOR_POLICY_URL = 'https://www.zillow.com/z/info/good-neighbor-policy/';
export const NO_CREDIT_SCORE_ZENDESK_URL = 'https://zillow.zendesk.com/hc/en-us/articles/360058073214';
export const PORTLAND_APPLICANT_RIGHTS_URL =
  'https://www.portland.gov/sites/default/files/2020-01/notice-30.01.086.c.3.c-application-and-screening-rights-and-responsibilities.pdf';
export const PORTLAND_MODIFICATION_ACCOMMODATION_URL =
  'https://www.portland.gov/phb/rental-services/documents/notice-3001086c3b-modification-or-accommodation/download';
export const PRIVACY_POLICY_URL = 'https://www.zillowgroup.com/zg-privacy-policy';
export const REASON_CODE_URL = 'https://www.reasoncode.org';
export const RENTAL_APPLICATION_REPORTS_LAWS_URL =
  'https://www.zillow.com/rental-manager/limits-rental-applications-reports/';
export const RESPECTFUL_RENTING_PLEDGE_URL = 'https://www.zillow.com/corp/respectful-renting-pledge/';
export const SAMPLE_INCOME_REPORT_URL =
  'https://files.zillowrentals.com/rental-applications/sample_verified_income_report.pdf';
export const SUPPORT_REQUEST_URL = 'https://www.zillow.com/rental-manager/submit-request';
export const TERMS_OF_USE_URL = 'https://www.zillowgroup.com/terms-of-use/';
export const TERMS_RENTER_URL = 'https://www.zillow.com/renter-hub/terms/Rental-User-Terms';
export const VANTAGE_SCORE_URL = 'https://vantagescore.com/consumers/how-credit-scores-work';
export const UNAVAILABLE_BACKGROUND_REPORT_FAQ =
  'https://www.zillow.help/article/why-does-my-background-report-show-unavailable-zd360026787753/';
export const RENTER_CANNOT_IDV_HELP = 'https://zillow.zendesk.com/hc/en-us/articles/360001470207';
export const LANDLORD_CANNOT_IDV_HELP = 'https://help.zillowrentalmanager.com/hc/en-us/articles/360058413693';
export const PRIVACY_POLICY = 'https://www.zillowgroup.com/zg-privacy-policy';

export const EXTERNAL_URLS = {
  APPLICATIONS_FAQ: APPLICATIONS_FAQ_URL,
  ASSISTANCE_ANIMALS: ASSISTANCE_ANIMALS_URL,
  CIC_SUPPORT: CIC_SUPPORT_URL,
  CO_APPLICANT_FAQ: CO_APPLICANT_FAQ_URL,
  CONDITIONAL_APPROVAL: CONDITIONAL_APPROVAL_URL,
  EXPERIAN_DISPUTE: EXPERIAN_DISPUTE_URL,
  EXPERIAN_NOTICE_TO_USERS: EXPERIAN_NOTICE_TO_USERS_URL,
  FAIR_HOUSING: FAIR_HOUSING_URL,
  NO_CREDIT_SCORE_ZENDESK: NO_CREDIT_SCORE_ZENDESK_URL,
  PORTLAND_APPLICANT_RIGHTS: PORTLAND_APPLICANT_RIGHTS_URL,
  PORTLAND_MODIFICATION_ACCOMMODATION: PORTLAND_MODIFICATION_ACCOMMODATION_URL,
  REASON_CODE: REASON_CODE_URL,
  RENTAL_APPLICATION_REPORTS_LAWS: RENTAL_APPLICATION_REPORTS_LAWS_URL,
  SUPPORT_REQUEST: SUPPORT_REQUEST_URL,
  TERMS_OF_USE: TERMS_OF_USE_URL,
  TERMS_RENTER: TERMS_RENTER_URL,
  VANTAGE_SCORE: VANTAGE_SCORE_URL,
  UNAVAILABLE_BACKGROUND_REPORT_FAQ: UNAVAILABLE_BACKGROUND_REPORT_FAQ,
  RENTER_CANNOT_IDV_HELP: RENTER_CANNOT_IDV_HELP,
  LANDLORD_CANNOT_IDV_HELP: LANDLORD_CANNOT_IDV_HELP,
} as const;
